export type ProfileIntegrationKey =
  | 'gmail'
  | 'google-calendar'
  | 'outlook'
  | 'outlook-calendar';

export interface ProfileIntegrationRow {
  key: ProfileIntegrationKey;
  title: string;
  iconSrc: string;
}

export const PROFILE_INTEGRATION_ROWS: ProfileIntegrationRow[] = [
  {
    key: 'gmail',
    title: 'Gmail',
    iconSrc: 'assets/icons/Gmail badge.svg',
  },
  {
    key: 'google-calendar',
    title: 'Google Calendar',
    iconSrc: 'assets/icons/google_calendar.svg',
  },
  {
    key: 'outlook',
    title: 'Outlook',
    iconSrc: 'assets/icons/outlook-email.svg',
  },
  {
    key: 'outlook-calendar',
    title: 'Outlook Calendar',
    iconSrc: 'assets/icons/outlook-calendar.svg',
  },
];
